import React from "react";

const OfferingSkeletonCard = () => (
  <div className="w-full border border-gray-200/80 rounded-2xl p-3 sm:p-4 bg-white shadow-sm flex flex-col gap-3 animate-pulse">
    {/* Image placeholder */}
    <div className="w-full h-44 sm:h-52 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 rounded-xl relative overflow-hidden">
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent animate-[shimmer_1.5s_infinite]" />
    </div>

    {/* Content placeholder */}
    <div className="flex flex-col gap-2 mt-1">
      {/* Title + Price row */}
      <div className="flex justify-between items-center w-full">
        <div className="h-6 w-3/5 bg-gray-200 rounded-md" />
        <div className="h-6 w-16 bg-orange-100 rounded-md" />
      </div>

      {/* Description lines */}
      <div className="h-3 w-4/5 bg-gray-200/80 rounded mt-1" />
      <div className="h-3 w-1/2 bg-gray-200/60 rounded" />

      {/* Button placeholder */}
      <div className="h-11 w-full bg-gradient-to-r from-orange-200/70 via-orange-100 to-orange-200/70 rounded-full mt-2" />
    </div>
  </div>
);

const OfferingSkeleton = ({ count = 2 }) => {
  return (
    <div className="w-full max-w-[30.5rem] mx-auto flex flex-col gap-6 px-3 py-2">
      {Array.from({ length: count }).map((_, i) => (
        <OfferingSkeletonCard key={i} />
      ))}
    </div>
  );
};

export default OfferingSkeleton;
